import React, { useState, useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";

import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import Fab from "@material-ui/core/Fab";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import { makeStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import LockOpenIcon from "@material-ui/icons/LockOpen";

import pageTitle from "../../utils/pageTitle";

import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";

import makeApiRequest from "../../utils/axios/new-axios";
import StatusChip from "../../components/acl/StatusChip";
import { fromUnixtime } from "../../utils/time";

import {
    ACL_GET_USERS_LIST_URL,
} from "../../config";

import { permissions, types, checkAcl } from "../../utils/acl";
import AddEditUserForm from "../../components/acl/AddEditUserForm";
import UnblockUserForm from "../../components/acl/UnblockUserForm";

const useStyles = makeStyles((theme) => ({

    avatar: {
        marginRight: 10,
        width: 27,
        height: 27,
        fontSize: 15,
        fontWeight: "bold",
        color: "#fff"
    },
    paper: {
        width: "100%",
        overflowX: "auto",
        marginBottom: theme.spacing(2),
        padding: "15px"
    }
}));

const initialParams = {
    action: "add",
    initialValues: {
        name: "",
        username: "",
        email: "",
        password: "",
        role: "",
    },
    userId: 0
};


export default function Users() {
    pageTitle("Admin Users");
    const dispatch = useDispatch();
    const classes = useStyles();
    const [isLoading, setIsloading] = useState(true);
    const [users, setUsers] = useState(null);

    const EDIT_ACCESS = checkAcl({ p: permissions.ADMIN_WEB_USER_MANAGEMENT, t: types.VIEW_AND_EDIT });

    //Add Edit User
    const [addEditParams, setAddEditParams] = useState(initialParams);
    const [openModal, setOpenModal] = useState(false);

    function handleOpenModal() {
        setOpenModal(true);
    }

    function handleCloseModal() {
        setOpenModal(false);
    }

    const addButtonClick = () => {
        setAddEditParams(initialParams);
        handleOpenModal();
    };

    const editButtonClick = user => {
        setAddEditParams({
            action: "edit",
            initialValues: {
                name: user.name,
                username: user.username,
                email: user.email,
                role: user.role,
                status: user.status
            },
            userId: user.id
        });
        handleOpenModal();
    };

    // Unblock user
    const [openUnblockModal, setOpenUnblockModal] = useState(false);
    const [unblockUserId, setUnblockUserId] = useState(null);

    function handleOpenUnblockModal() {
        setOpenUnblockModal(true);
    }

    function handleCloseUnblockModal() {
        setOpenUnblockModal(false);
    }

    const unblockButtonClick = (userId) => {
        setUnblockUserId(userId)
        handleOpenUnblockModal();
    };

    useEffect(() => {
        makeApiRequest({
            url: ACL_GET_USERS_LIST_URL.url,
            method: ACL_GET_USERS_LIST_URL.method,
        })
            .then((response) => {
                setIsloading(false);
                setUsers(response.data);
            })
            .catch((error) => {
                setIsloading(false);
                dispatch(
                    showErrorAlert(
                        "User Fetch Error : " +
                        (!!error.response
                            ? `${error.response.status}! - ${error.response.data.errorMessage}`
                            : error.message)
                    )
                );
            });
        // eslint-disable-next-line
    }, []); // [] is required to make sure that it runs only once


    return (
        <Fragment>
            <ComponentLoader isLoading={isLoading} />
            {!isLoading && !!users && (
                <Container style={{ padding: "10px" }}>
                    <h3>Admin Users</h3>
                    <Paper className={classes.paper}>
                        {users.length > 0 ?
                            (<Fragment>
                                <Table className={classes.table} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Username</TableCell>
                                            <TableCell>Email</TableCell>
                                            <TableCell>Role</TableCell>
                                            <TableCell>Last Login</TableCell>
                                            <TableCell>Status</TableCell>
                                            {EDIT_ACCESS && <TableCell>Actions</TableCell>}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {users.map(user => (
                                            <TableRow key={user.id}>
                                                <TableCell>
                                                    <Avatar
                                                        className={classes.avatar}
                                                    >
                                                        {user.name.substring(0, 1).toUpperCase()}
                                                    </Avatar>
                                                </TableCell>
                                                <TableCell>{user.name}</TableCell>
                                                <TableCell>{user.username}</TableCell>
                                                <TableCell>{user.email}</TableCell>
                                                <TableCell>{user.roleName}</TableCell>
                                                <TableCell>{fromUnixtime(user.lastLogin)}</TableCell>

                                                <TableCell>
                                                    <StatusChip status={user.status} />
                                                </TableCell>
                                                {EDIT_ACCESS && <TableCell>

                                                    <Box display="flex" flexWrap="no-wrap">
                                                        {user.id !== 0 && (
                                                            <IconButton
                                                                className={classes.button}
                                                                aria-label="edit-user"
                                                                onClick={() =>
                                                                    editButtonClick(user)
                                                                }
                                                                size="small"
                                                            >
                                                                <EditIcon />
                                                            </IconButton>)}
                                                        {user.status > 1 &&
                                                            <IconButton
                                                                className={classes.button}
                                                                aria-label="unblock-user"
                                                                onClick={() =>
                                                                    unblockButtonClick(user.id)
                                                                }
                                                                size="small"
                                                            >
                                                                <LockOpenIcon />
                                                            </IconButton>}

                                                    </Box>

                                                </TableCell>}
                                            </TableRow>

                                        ))}
                                    </TableBody>
                                </Table>
                            </Fragment>) : <h4>No results</h4>
                        }
                    </Paper>
                    {EDIT_ACCESS &&
                        <Box
                            justifyContent="center"
                            display={isLoading ? "none" : "flex"}
                            style={{ marginTop: "15px" }}
                        >
                            <Fab
                                size="small"
                                color="primary"
                                aria-label="add"
                                onClick={addButtonClick}
                            >
                                <AddIcon />
                            </Fab>
                        </Box>}
                </Container>)}
            {EDIT_ACCESS &&
                <Fragment>
                    <AddEditUserForm
                        action={addEditParams.action}
                        openModal={openModal}
                        handleCloseModal={handleCloseModal}
                        initialValues={addEditParams.initialValues}
                        userId={addEditParams.userId}
                    />
                    <UnblockUserForm
                        openModal={openUnblockModal}
                        handleCloseModal={handleCloseUnblockModal}
                        userId={unblockUserId}
                    />
                </Fragment>}
        </Fragment>
    )
}
